import { Box, Button } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmComp from "src/components/shared/ConfirmComp";
import DeleteIcon from "src/components/shared/icon/DeleteIcon";
import UpdateIcon from "src/components/shared/icon/UpdateIcon";
import ViewIcon from "src/components/shared/icon/ViewIcon";
import useAppGlobal from "src/context/useAppGlobal";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
import useProductRemove from "src/hooks/product/useProductRemove";
import useQueryParams from "src/hooks/useQueryParams";
import { v4 as uuid } from "uuid";
import ProductDetailView from "../ProductDetail/ProductDetailView";
import useAuthGlobal from "src/context/useAuthGlobal";
import { USER_ROLE_TYPE } from "src/constant";

export default function useProductAction() {
  const navigate = useNavigate();
  const permissionCheck = useRoleCheck();
  const [option, setOption] = useQueryParams();
  const { userMe } = useAuthGlobal();
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const [productId, setProductId] = useState();
  const { trigger: removeProd } = useProductRemove(productId);
  const handleProductUpdate = (item) => {
    setOption({ ...option, productId: item?._id, status: "update" });
  };
  const handleProductRemove = async (item) => {
    const isSA = permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]) ? { confirm: true } : null;
    const res = await removeProd({
      body: { id: item?._id, ...isSA },
    });
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  const onInventoryRedirect = () => {
    navigate("/warehouse-management/inventory?tab=inventory");
    closeDialog();
  };

  const handleViewProduct = (item) => {
    handleOpenDialog({
      title: "Chi tiết sản phẩm",
      content: <ProductDetailView item={item} />,
      size: "md",
    });
  };

  const action = [
    {
      id: uuid(),
      icon: <ViewIcon />,
      onClick: (item) => handleViewProduct(item),
      type: "icon",
      disabled: !permissionCheck([PERMISSIONS.VIEW_PRODUCT]),
    },
    {
      id: uuid(),
      icon: <UpdateIcon />,
      onClick: (item) => handleProductUpdate(item),
      type: "icon",
      disabled: !permissionCheck([PERMISSIONS.UPDATE_PRODUCT]),
    },
    {
      id: uuid(),
      disabled: userMe?.role?.code === USER_ROLE_TYPE.SUPER_ADMIN && permissionCheck([PERMISSIONS.DELETE_PRODUCT]) ? false : true,
      icon: <DeleteIcon />,
      onClick: (item) => {
        setProductId(item?._id);
        handleOpenDialog({
          content: (
            <ConfirmComp
              custom={{
                label: (
                  <Box>
                    Việc xoá sản phẩm sẽ xoá hết tồn kho hiện tại của sản phẩm.
                    <Button
                      sx={{ fontWeight: 700, fontSize: "10px", py: "0 !important" }}
                      onClick={onInventoryRedirect}
                    >
                      Xem chi tiết tồn kho
                    </Button>
                  </Box>
                ),
              }}
              name={item?.name}
              onConfirm={() => handleProductRemove(item?._id)}
            />
          ),
          size: "md",
        });
      },
      type: "icon",
    },
  ];
  return action;
}
